<template>
    <rkm-form
        v-if="model"
        ref="RkmFormCondutor"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-select
                    :options="form.condutores"
                    :validations="validations.usuarioId"
                    label="Condutor"
                    text-field="nome"
                    value-field="id"
                    v-model="model.usuarioId"
                    show-default-option
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    label="CNH"
                    :validations="validations.numeroCnh"
                    v-model="model.numeroCnh"
                    type="number"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-select
                    :options="form.categorias"
                    :validations="validations.categoriaCnhId"
                    label="Categoria CNH"
                    text-field="letra"
                    value-field="id"
                    v-model="model.categoriaCnhId"
                    show-default-option
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-date-picker
                    label="Vencimento da habilitação"
                    v-model="model.vencimentoHabilitacao"
                    :validations="validations.vencimentoHabilitacao"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    label="Matrícula"
                    v-model="model.matricula"
                />
            </rkm-col>

            <rkm-col cols="2">
                <rkm-form-checkbox
                    :label="false"
                    inline
                    v-model="model.bloqueado"
                >
                    Inativar
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>

// Mixins.
import { error, repository, data, object, stringCase } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    computed: {
        validations() {
            return {
                categoriaCnhId: { required: true },
                usuarioId: { required: true },
                numeroCnh: { required: true, max: 11 },
                vencimentoHabilitacao: { required: true },
            }
        },
    },
    created() {
        this.repositories = {
            condutor: this.getConectaSusRepository('transportePaciente.condutor')
        }
    },
    data: () => ({
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions([ 'setLoading', 'unsetLoading' ]),
        load() {
            this.setLoading()

            const request = this.id ?
                this.repositories.condutor.edit(this.id) :
                this.repositories.condutor.create()

            request
                .then(response => {
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)

                    this.model.bloqueado = this.model.bloqueado == 1
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {
            this.$refs.RkmFormCondutor.validate()
                .then(valid => {
                    if (valid) {

                        this.setLoading()

                        let data = this.clone(this.model)

                        data.bloqueado = data.bloqueado ? 1 : 0;

                        this.formateDates(data, ['vencimentoHabilitacao'], 'YYYY-MM-DD')

                        if (!data.id) {

                            delete data.id
                        }

                        data = this.camelObjectKeysToSnakeRecursive(data)

                        const request = data.id ?
                            this.repositories.condutor.update(data.id, data) :
                            this.repositories.condutor.store(data)

                        request
                            .then(response => {
                                this.showSaveNotification()
                                this.$emit('save', response)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                })
        },
    },
    mixins: [ error, repository, data, object, stringCase ],
    mounted() {
        this.load()
    },
    props: {
        id: { type: [Number], default: null },
        numeroCnh: { type: [Number], default: null }
    }
}
</script>